import { Link, Navigate, useLocation } from 'react-router-dom'
import { useCurrentShow } from '@/context/current-show'

export function LegacyShowRedirect() {
  const { currentShow } = useCurrentShow()
  const { pathname, search, hash } = useLocation()
  if (currentShow?.slug) {
    const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase()
    const sectionPath =
      normalizedPath === '/classes'
        ? '/show-classes'
        : normalizedPath === '/reports/club-participation'
          ? '/reports/club-participation/view'
          : pathname
    return <Navigate replace to={`/${currentShow.slug}${sectionPath}${search}${hash}`} />
  }
  return (
    <div className="space-y-3">
      <h1 className="text-xl font-semibold">Choose a show</h1>
      <p>Open a show from the Shows page to continue.</p>
      <Link className="underline" to="/shows">
        Go to Shows
      </Link>
    </div>
  )
}
